export const UPDATE_LIST = 'user/UPDATE_LIST';

export default (state = { list: [] }, action) => {
  switch (action.type) {
    case UPDATE_LIST:
      return {
        ...state,
        list: [...action.list],
      };
    default:
      return state;
  }
};
